import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import FormikRadioButton from '../../../ui/FormikRadioButton';
import CalendarComponent from '../../../global/calendar-component';
import { getBookings, getCalendar, updateFormData, setListing, updateListing } from '../actions';
import { Link } from 'react-router-dom';
import { DateUtils } from 'react-day-picker';
import moment from 'moment';
import { populateFormDataFromListing } from '../helpers';
import { getAdminModifiers, dateRange } from '../../../../calendarHelper';
import ToolTip from '../../../ui/ToolTip';
import { AvailabilitySchema } from '../validation';
import { handleFile } from '../../dashboard/owner-dashboard-component';

const mapStateToProps = state => ({
  bookings: state.Listing.listingBookings,
  calendars: state.Listing.calendars
});

class AvailabilityAndPricing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      calendars: [],
      editBookingSettings: false,
      bookingSettingsEditClicked: false,
      selectedDays: [],
      singleDay: true,
      from: undefined,
      to: undefined,
      width: window.innerWidth,
      adminModifiers: {},
      dateRangeException: ""
    }

    this.initFormData = {
      adjustment: '',
      availability: ''
    }
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.listing.calendars !== this.props.listing.calendars) {
      this.props.dispatch(getBookings(this.props.listing._id));
      this.setState({ calendars: [] });
      this.handleCalendarInfo();
    }
  }

  componentWillMount() {
    this.handleCalendarInfo();
    this.props.dispatch(getBookings(this.props.listing._id));
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  handleCalendarInfo() {
    let listingCalendars = this.props.listing.calendars;
    listingCalendars.forEach(cal => {
      getCalendar(cal, response => handleFile(response, this, this.state));
    });
  }

  dateHandlerSingleDay = (day, selected) => {
    let selectedDaysCopy = this.state.selectedDays.slice();

    if (selected) {
      const selectedIndex = selectedDaysCopy.findIndex(selectedDay =>
        DateUtils.isSameDay(selectedDay, day)
      );
      selectedDaysCopy.splice(selectedIndex, 1);
    } else {
      selectedDaysCopy.push(day);
    }

    this.pricingCallback(selectedDaysCopy);
  }

  dateHandlerPart = (day, modifiers) => {
    if (this.state.from.toString() === day.toString()) {
      let days = [];
      this.pricingCallback(days, undefined, undefined);
    } else {
      let range = DateUtils.addDayToRange(day, this.state);

      let rangeCopy = Object.assign({}, range);
      // "to" will be undefined on first click
      if (rangeCopy.to !== undefined) {
        let days = dateRange(rangeCopy.from, rangeCopy.to);
        this.pricingCallback(days, rangeCopy.from, rangeCopy.to, modifiers);
      } else {
        let days = dateRange(rangeCopy.from, rangeCopy.from);
        this.pricingCallback(days, rangeCopy.from, rangeCopy.from);
      }
    }
  }

  dateHandler = (day, selectedDay, modifiers) => {
    if (this.state.singleDay === true) {
      this.dateHandlerSingleDay(day, selectedDay)
    } else {
      if (this.state.from !== undefined && this.state.from !== null && day !== undefined) {
        this.dateHandlerPart(day, modifiers);
      } else {
        let range = DateUtils.addDayToRange(day, this.state);

        let rangeCopy = Object.assign({}, range);
        // "to" will be undefined on first click
        if (rangeCopy.to !== undefined) {
          let days = dateRange(rangeCopy.from, rangeCopy.to);
          this.pricingCallback(days, rangeCopy.from, rangeCopy.to);
        } else {
          let days = dateRange(rangeCopy.from, rangeCopy.from);
          this.pricingCallback(days, rangeCopy.from, rangeCopy.from);
        }
      }
    }
  }

  editListing = (page) => {
    let { history, dispatch } = this.props;
    let formData = populateFormDataFromListing(this.props.listing);
    dispatch(updateFormData(formData));
    history.push('/dashboard/listing/edit/' + page);
  }

  editDiscounts = (page) => {
    this.editListing(page);
  }

  update = (values, resetForm) => {
    let { dispatch, listing } = this.props;
    let currentListingCopy = Object.assign({}, listing);
    this.state.selectedDays.forEach(x => {
      currentListingCopy.pricing.overrides = currentListingCopy.pricing.overrides.filter(y => !moment(y.date).isSame(x, 'day'));
    });
    this.state.selectedDays.forEach(x => {
      if (values.adjustment !== listing.pricing.baseFee) {
        currentListingCopy.pricing.overrides.push({
          availability: values.availability,
          price: values.adjustment ? values.adjustment : listing.pricing.baseFee,
          date: x
        });
      }
    });


    dispatch(setListing(currentListingCopy));
    dispatch(updateListing());
    resetForm(this.initFormData);
    this.setState({ selectedDays: [], from: undefined, to: undefined });
  }

  bookingSettingsClicked = (setting) => {
    if (setting) {
      this.bookingCallback(setting);
    }
    this.setState({ bookingSettingsEditClicked: !this.state.bookingSettingsEditClicked });
  }

  renderCalendarMessage = () => {
    let { listing, calendars } = this.props;

    if (!listing.calendars.length)
      return null;

    return (listing.calendars.length !== calendars.length ?
      <div className="loading-calendar-data">Loading calendar data...</div> :
      <span className="calendar-sync"><i className="fas fa-check-circle"></i>Calendars successfully synced.</span>
    )
  }

  pricingCallback = (dates, from, to, modifiers) => {
    if (modifiers && modifiers.cw && modifiers.cwcheckout) {
      var sameDayFound = modifiers.cw.find(cw => {
        return (dates.find(d => d.isSame(cw, 'day')) && !modifiers.cwcheckout.find(co => moment(co).isSame(cw, 'day')));
      });
      if (sameDayFound) {
        this.setState({ from: undefined, to: undefined, dateRangeException: "You can not change the the price on already booked dates. Please select a valid range." });
        return;
      }
    }

    this.setState({ selectedDays: dates });

    // "to" will be undefined on first click
    if (to !== undefined) {
      this.setState({ from: from, to: to, dateRangeException: "" });
    } else {
      this.setState({ from: from, to: from, dateRangeException: "" });
    }

    if (dates.length === 0 && from === undefined && to === undefined) {
      this.setState({ selectedDays: [], from: null, to: null, dateRangeException: "" });
    }
  }

  dayCallback = (singleDay) => {
    this.setState({ singleDay: singleDay, selectedDays: [], from: undefined, to: undefined });
  }

  bookingCallback = (value) => {
    let { dispatch, listing } = this.props;

    let currentListingCopy = Object.assign({}, listing);
    currentListingCopy.bookingSetting = value;
    listing.bookingSetting = value;
    dispatch(setListing(currentListingCopy));
    setTimeout(() => dispatch(updateListing()), 240);
  }

  getRenderParams = (bookings, listing) => {
    const calendarBookings = bookings ? bookings.filter(x =>
      x.bookingRequestStatus === 'Accepted'
      && x.bookingPaymentStatus !== 'Cancelled'
      && x.bookingPaymentStatus !== 'Pending'
    ) : [];

    const activeDiscounts = listing.discounts.filter(d => d.validDates.length === 0 ||
      d.validDates.find(vd => moment(vd.startDate).isSameOrAfter(moment(), 'd') || (vd.endDate && moment(vd.endDate).isSameOrAfter(moment(), 'd'))));

    const activeAddons = listing.addOns.filter(a => a.isActive
      && (a.validDates.length === 0 || a.validDates.find(vd => moment(vd.startDate).isSameOrAfter(moment(), 'd') ||
        (vd.endDate && moment(vd.endDate).isSameOrAfter(moment(), 'd'))))
      && (a.totalInventory === 0 || (a.totalInventory > 0 && a.inventory !== 0))
    );

    return {
      calendarBookings,
      activeDiscounts,
      activeAddons
    }
  }

  renderActiveDiscounts = (activeDiscounts) => {
    if (!activeDiscounts.length) {
      return (
        <tr>
          <td>There are no discounts for this listing.</td>
        </tr>
      )
    }

    return activeDiscounts.slice(0, 2).map((discount, i) => {
      return (
        <tr key={i}>
          <td>{discount.code}</td>
          {discount.discountType === "Percentage"
            ?
            <td>{discount.discountPercentage}% off</td>
            :
            <td>${discount.discountDollarAmount} off</td>
          }
        </tr>
      )
    })
  }

  renderListingCalenderElement = (cal, maxNameLength, calName, i) => {
    if (calName === "Other") {
      let otherCalNameLength = cal.length > maxNameLength ? maxNameLength : calName.length;
      let otherCalName = cal.length <= maxNameLength ? cal.substring(0, otherCalNameLength) : cal.substring(0, otherCalNameLength) + "...";
      return (
        <tr key={i}>
          <td colSpan="2">{`${calName} (${otherCalName})`}</td>
        </tr>
      )
    } else {
      return (
        <tr key={i}>
          <td colSpan="2">{calName}</td>
        </tr>
      )
    }
  }

  renderListingCalenders = (listing, width) => {
    if (!listing.calendars.length) {
      return (
        <tr>
          <td colSpan="2">There are no synced calendars for this listing.</td>
        </tr>
      )
    }

    return listing.calendars.map((cal, i) => {
      let isMobile = width <= 480;
      let maxNameLength = isMobile ? 14 : 17;
      let calName;

      if (cal.includes("airbnb"))
        calName = "Airbnb";
      else if (cal.includes("vrbo") || cal.includes("homeaway"))
        calName = "VRBO";
      else
        calName = "Other"

      return this.renderListingCalenderElement(cal, maxNameLength, calName, i);
    })
  }

  renderListingTable(listing, activeDiscounts, activeAddons, showMoreDiscounts, showMoreAddons, width, instantToolTip, requestToolTip
  ) {
    return (
      <table className="table table-borderless listing-pricing">
        <tbody>
          <tr className="table-head">
            <th scope="col">Base Pricing</th>
            <th scope="col text-right"><Link className="underline-link text-right" to='#' onClick={() => this.editListing('pricing')}>Edit</Link></th>
          </tr>
          <tr>
            <td scope="row">Base Fee per Night</td>
            <td>${listing.pricing.baseFee}</td>
          </tr>
          {
            !!listing.pricing.weekend_fee && !!listing.pricing.weekend_fee.value &&
            <tr>
              <td scope="row">Base Fee per Night (Weekend Stay)</td>
              <td>${listing.pricing.weekend_fee.value}</td>
            </tr>
          }
          {
            !!listing.pricing.extended_fee && !!listing.pricing.extended_fee.value &&
            <tr>
              <td scope="row">Base Fee per Night (Extended Stay)</td>
              <td>${listing.pricing.extended_fee.value}</td>
            </tr>
          }
          <tr>
            <td scope="row">Cleaning Fee</td>
            <td>${listing.pricing.cleaningFee}</td>
          </tr>
          <tr>
            <td scope="row">Pet Fee</td>
            <td>${listing.pricing.petFee}</td>
          </tr>
          <tr>
            <td scope="row">Security Deposit</td>
            <td>${listing.pricing.deposit}</td>
          </tr>
          <tr>
            <td scope="row">Local Tax</td>
            <td>{(listing.pricing.localTax).toFixed(2)}%</td>
          </tr>
          <tr>
            <td scope="row">State Tax</td>
            <td>{(listing.pricing.stateTax).toFixed(2)}%</td>
          </tr>
          <tr className="table-head">
            <th scope="col">Discounts</th>
            <th scope="col"><Link className="underline-link text-right" to='#' onClick={() => this.editDiscounts('discounts')}>
              {activeDiscounts.length > 0 ? 'Edit' : 'Add'}</Link></th>
          </tr>
          {this.renderActiveDiscounts(activeDiscounts)}
          {showMoreDiscounts && (<tr><td><Link className="underline-link text-right" to='#' onClick={() => this.editDiscounts('discounts')}>
            View {activeDiscounts.length - 2} more...</Link></td><td></td></tr>)}
          <tr className="table-head">
            <th scope="row">Add-Ons</th>
            <td className="font-weight-bold"><Link className="underline-link text-right" to='#' onClick={() => this.editListing('addOns')}>
              {activeAddons.length > 0 ? 'Edit' : 'Add'}
            </Link></td>
          </tr>
          {activeAddons.length > 0 ?
            activeAddons.slice(0, 2).map((addOn, i) => {
              return (
                <tr key={i}>
                  <td>{addOn.name}</td>
                  <td>${addOn.price}</td>
                </tr>
              )
            })
            : <tr>
              <td>There are no add-ons for this listing.</td>
            </tr>
          }
          {showMoreAddons && (<tr><td><Link className="underline-link text-right" to='#' onClick={() => this.editListing('addOns')}>
            View {activeAddons.length - 2} more...</Link></td><td></td></tr>)}
          <tr className="table-head">
            <th scope="row">Synced Calendars</th>
            <td className="font-weight-bold"><Link className="underline-link text-right" to='#' onClick={() => this.editListing('calendars')}>
              {listing.calendars.length > 0 ? 'Edit' : 'Add'}
            </Link></td>
          </tr>
          {this.renderListingCalenders(listing, width)}
          <tr className="table-head">
            <th scope="row">Booking Settings</th>
            <td className="font-weight-bold">
              <span className="underline-link text-right" onClick={() => this.bookingSettingsClicked()}>
                {this.state.bookingSettingsEditClicked ? "Close" : "Edit"}
              </span>
            </td>
          </tr>
          {!this.state.bookingSettingsEditClicked &&
            <tr>
              {listing.bookingSetting === "Instant" ? <td>Instant Book</td> : <td>Request a Stay</td>}
            </tr>
          }
          {this.state.bookingSettingsEditClicked &&
            <tr>
              <td className="fieldgroup booking-settings" colSpan="3">
                <input type="radio" onChange={() => this.bookingSettingsClicked("Instant")}
                  name="bookingSetting" value="Instant" checked={listing.bookingSetting === "Instant"} />
                <span>Instant Book <ToolTip position="right" message={instantToolTip}><i className="far fa-question-circle"></i></ToolTip></span>
              </td>
            </tr>
          }
          {this.state.bookingSettingsEditClicked &&
            <tr>
              <td className="fieldgroup booking-settings" colSpan="3">
                <input type="radio" onChange={() => this.bookingSettingsClicked("Request")}
                  name="bookingSetting" value="Request" checked={listing.bookingSetting === "Request"} />
                <span>Request a Stay <ToolTip position="right" message={requestToolTip}><i className="far fa-question-circle"></i></ToolTip></span>
              </td>
            </tr>
          }
        </tbody>
      </table>
    )
  }

  render() {
    let { listing, bookings } = this.props;
    let { width } = this.state;
    let instantToolTip = "Allow renters to book your property instantly for available dates.";
    let requestToolTip = "Review the renter's profile and request before accepting or denying a stay request";

    const renderParams = this.getRenderParams(bookings, listing);

    let showMoreAddons = renderParams.activeAddons.length > 2;
    let showMoreDiscounts = renderParams.activeDiscounts.length > 2;

    return (
      <div className="row availability-details">
        <div className="col-12 col-lg-8 mb-2">
          {this.state.calendars.length !== listing.calendars.length || !bookings ?
            <div className="loading-calendar-data">Loading calendar data...</div> :
            <CalendarComponent
              modifiers={getAdminModifiers(listing.pricing.overrides, this.state.calendars, renderParams.calendarBookings)}
              baseFee={listing.pricing.baseFee}
              weekendFee={listing.pricing.weekend_fee}
              dateHandler={this.dateHandler}
              selectedDaysParent={this.state.selectedDays}
              singleDay={this.state.singleDay}
              from={this.state.from}
              to={this.state.to} />
          }
        </div>
        <div className="col-12 col-lg-4">
          <Formik initialValues={this.initFormData} validationSchema={AvailabilitySchema}>
            {({ values, setSubmitting, errors, validateField, resetForm }) => {
              return (<div>
                <h5 class="mb-2 avaibility-title">Manage Availability & Pricing</h5>
                <div class="mb-2">Select <strong>Single Day(s)</strong> or a <strong>Date Range</strong> on the calendar to mark as <strong>Unavailable</strong> or
                  <strong>Available</strong> at a specific base price per night. Then click the <strong>Update Calendar</strong> button to <strong>Save</strong> your changes.</div>
                <div className="row radio">
                  <div className="col-sm-12 px-0">
                    <label>
                      <input type="radio"
                        name="type"
                        onChange={() => this.dayCallback(true)}
                        value="singleDay"
                        checked={this.state.singleDay}
                      />
                      Select Single Day
                    </label>
                  </div>
                  <div className="col-sm-12 px-0">
                    <label>
                      <input type="radio"
                        name="type"
                        onChange={() => this.dayCallback(false)}
                        value="dateRange"
                        checked={!this.state.singleDay}
                      />
                      Select Date Range
                    </label>
                  </div>
                </div>
                {!this.state.singleDay && this.state.dateRangeException && <div className="range-exception">
                  <p>{this.state.dateRangeException}</p>
                </div>}
                <div className="radio-button-description mb-2">
                  {this.state.singleDay ? <p>Select <strong>Individual</strong> or <strong>Multiple</strong> days to change their price or make unavailable</p> :
                    <p>Select <strong>first</strong> and <strong>last</strong> dates to select a range of dates to change their price or make unavailable</p>}
                </div>
                <div className="fieldgroup row mt-0 ml-0">
                  <div className="fieldgroup col-12 col-sm-3 m-0 pl-0">
                    <FormikRadioButton
                      name="availability"
                      value="Available"
                      disabled={this.state.selectedDays.length === 0}
                    />
                    <FormikRadioButton
                      name="availability"
                      value="Unavailable"
                      disabled={this.state.selectedDays.length === 0}
                    />
                  </div>
                </div>
                <div className="row mb-4">
                  <div className="col-lg-12 col-6 mt-0 mx-0 mobile-flex-center d-flex align-items-center">
                    <label className="mb-2">Price per Night:</label>
                  </div>
                  <div className="col-lg-12 col-6 mt-0 mx-0 mobile-flex-center">
                    <span className="dollar-field price-override">
                      <Field
                        name="adjustment"
                        type="number"
                        className="form-control"
                        disabled={!(this.state.selectedDays.length > 0 && values.availability === "Available")} />
                    </span>
                    <ErrorMessage name="adjustment" component="div" className="error-message col-12" />
                  </div>
                </div>
                <div className="button-row row text-center">
                  <div className="col mb-4 mx-0 px-0">
                    <button disabled={!(this.state.selectedDays.length > 0 && values.availability)} className="btn-secondary mx-0"
                      type="button" onClick={() => this.update(values, resetForm)}>Update Calendar</button>
                  </div>
                </div>
              </div>)
            }}
          </Formik>
          {this.renderListingTable(listing, renderParams.activeDiscounts, renderParams.activeAddons, showMoreDiscounts, showMoreAddons, width, instantToolTip, requestToolTip)}
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps)(AvailabilityAndPricing)
